<template>
  <div :id="wrapperID" class="simpleChartWrapper">
    <div :id="myId" class="simpleChartDiv"></div>
  </div>
</template>

<script>
import { createChart } from "lightweight-charts";

export default {
  name: "SimpleChart",
  props: {
    chartData: {
      default: null
    }
  },
  watch: {
    chartData() {
      this.refreshChart(this.chartData);
    }
  },
  data() {
    return {
      myId: null,
      chart: null,
      lineSeries: null
    };
  },
  computed: {
    wrapperID() {
      return this.myId + "_wrapper";
    }
  },
  created() {
    this.myId = "simpleChart_" + Math.round(Math.random() * 9999999);
  },
  mounted() {
    new ResizeObserver(entries => {
      if (!this.chart || entries.length === 0) {
        return;
      }

      const newRect = entries[0].contentRect;
      this.chart.applyOptions({ height: newRect.height, width: newRect.width });
      this.chart.timeScale().fitContent();
    }).observe(document.getElementById(this.wrapperID));
  },
  methods: {
    refreshChart(data) {
      if (!this.lineSeries) {
        this.chart = createChart(document.getElementById(this.myId), {
          width: 800,
          height: 300
        });
        this.chart.applyOptions({
          timeScale: {
            timeVisible: true
          }
        });
        this.lineSeries = this.chart.addLineSeries();
      }

      this.lineSeries.setData(data);
      this.chart.timeScale().fitContent();
    }
  }
};
</script>

<style scoped>
.simpleChartWrapper {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 300px;
}
.simpleChartDiv {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
